import { render } from "./message-revoked.vue?vue&type=template&id=67ee702b&scoped=true&ts=true"
import script from "./message-revoked.vue?vue&type=script&lang=ts"
export * from "./message-revoked.vue?vue&type=script&lang=ts"

import "./message-revoked.vue?vue&type=style&index=0&id=67ee702b&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ee702b"]])

export default __exports__